import { TriangleAlert } from "lucide-react";
import { useMarket, useT } from "../../../i18n";
import { pluralizeCount } from "../../../i18n/plural";
import { getMarketProfile } from "../../../market/marketProfile";
import type { SafetyFlag } from "../safetyFlags";
import "./SafetyFlagNotice.css";

interface SafetyFlagNoticeProps {
	flags: SafetyFlag[];
	onReview: () => void;
}

/**
 * The Safety & planning flags, shown where the design is being changed. A
 * longer sauna that raises a flag says so here, next to the slider that did
 * it, instead of only as a number on the last tab.
 */
export function SafetyFlagNotice({ flags, onReview }: SafetyFlagNoticeProps) {
	const t = useT();
	const { locale } = getMarketProfile(useMarket());
	const count = pluralizeCount(
		t,
		"workspace_badgeRulesFlags",
		flags.length,
		locale,
	);

	return (
		<section className="safety-flag-notice" aria-label={t.rules_tabLabel}>
			{/* Always mounted, so a flag appearing or clearing is announced. */}
			<p className="safety-flag-notice__status" aria-live="polite">
				{flags.length > 0 ? count : ""}
			</p>
			{flags.length > 0 && (
				<details className="safety-flag-notice__details">
					<summary>
						<TriangleAlert size={16} strokeWidth={2} aria-hidden="true" />
						<span>{t.safetyNotice_title.replace("{count}", count)}</span>
					</summary>
					<ul>
						{flags.map((flag) => (
							<li key={flag.id}>{flag.text}</li>
						))}
					</ul>
					<button
						type="button"
						className="safety-flag-notice__review"
						onClick={onReview}
					>
						{t.safetyNotice_review}
					</button>
				</details>
			)}
		</section>
	);
}
